document.addEventListener('DOMContentLoaded',function(){var button=document.querySelector('.menu-toggle');var nav=document.getElementById('MainNavigation');if(button&&nav){button.addEventListener('click',function(){var expanded=button.getAttribute('aria-expanded')==='true';button.setAttribute('aria-expanded',String(!expanded));nav.classList.toggle('is-open',!expanded);});}});

// Keep the visible price aligned with the variant submitted by the native form.
document.addEventListener('change', function (event) {
  const select = event.target;
  if (!(select instanceof HTMLSelectElement) || !select.matches('.product-form select[name="id"]')) return;
  const option = select.selectedOptions[0];
  const productPage = select.closest('.product-page');
  const price = productPage?.querySelector('[data-product-price]');
  if (!option || !price || !option.dataset.variantPrice) return;
  price.textContent = option.dataset.variantPrice;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', option.value);
  window.history.replaceState(window.history.state, '', url);
});
